import {colors} from "../../configuration/colors"
import {debounce} from "debounce";
import moment from "moment";
import {blobToBase64} from "../../helper/files"

const plugin = {
    install: function (Vue, options) {
        const app = options.app;

        Vue.prototype.$capitalize = capitalize;
        Vue.prototype.$ucfirst = ucfirst;
        Vue.prototype.$debounce = debounce;
        Vue.prototype.$color = colors;
        Vue.prototype.$asset = asset;
        Vue.prototype.$assetRemote = (basePath, isAbsolutePath, authenticate) => assetRemote(app, basePath, isAbsolutePath, authenticate);
        Vue.prototype.$stripHTML = stripHTML;
        Vue.prototype.$isString = isString();

        Vue.prototype.$t = (key, options) => app.translationManager.translate(key, options);
        Vue.filter('reverse', reverse);
        Vue.filter('stripHTML', stripHTML);
        Vue.filter('date', date);
    }
}


export function capitalize(string) {
    return string && isString(string) ? string.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '';
}

export function ucfirst(string) {
    return string && isString(string) ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

export function asset(basePath) {
    return basePath && isString(basePath) ? '/' + basePath : '';
}

export async function assetRemote(app, basePath, isAbsolutePath = false, authenticate = true) {
    const imgUrl = !isAbsolutePath ?
        (basePath && isString(basePath) ? process.env.VUE_APP_API_ROOT_URL + '/app/media/frontend/' + basePath : '') :
        basePath;
    const authToken = app.store.state.authToken;

    if (!authenticate) {
        return imgUrl;
    }

    // Use Authentication
    let response = await fetch(imgUrl, {headers: {'Authorization': 'Bearer ' + authToken}});
    let imageBlob = await response.blob();

    return blobToBase64(imageBlob)
}

export function reverse(array) {
    return Array.isArray(array) ? array.slice().reverse() : [];
}

export function stripHTML(html) {
    if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html')
        return doc.body.textContent || ""
    } else {
        return html
    }
}

export function isString(string) {
    return typeof string == 'string' || string instanceof String;
}

export function date(timestamp, format = 'DD/MM/YYYY HH:mm') {
  return moment(timestamp).format(format);
}

export default plugin